// extracted by mini-css-extract-plugin
module.exports = {"cookiePreferencesLink":"_1B1IYlqX8IICSvBzGbehvP","parentZone":"_1fNKRUBHsusbTnVchXLB_Z"};